module.exports = __webpack_public_path__ + "static/concrete-driveways-261919d043fa3a61a62a8930eee35514.jpg";